import React, { Component } from 'react';

class SimpleDateInput extends Component {
    constructor(props){
        super(props);

        this.state = {
            value: ''
        }

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event){
        const { onChange } = this.props;
        const dateInputeRegExp = /^\d{1,8}$/;
        let onlyDigits = event.target.value.split("/").join("");
        let processedValue = '';

        if(dateInputeRegExp.test(onlyDigits) || !onlyDigits){

            processedValue = onlyDigits;

            if(/^(\d{2})(\d{2})(\d{1,4})$/.test(onlyDigits)){
                processedValue = onlyDigits.replace(/^(\d{2})(\d{2})(\d{1,4})$/, '$1/$2/$3');
            }

            if(/^(\d{2})(\d{1,2})$/.test(onlyDigits)){
                processedValue = onlyDigits.replace(/^(\d{2})(\d{1,2})$/, '$1/$2');
            }

            if(/^(\d{2})$/.test(onlyDigits)){
                processedValue = onlyDigits.replace(/^(\d{2})$/, '$1');
            }

            this.setState({
                ...this.state,
                value: processedValue
            });
            onChange({
                ...event,
                target: {
                    ...event.target,
                    value: processedValue,
                }
            });  
            
        }
    }

    render(){
        const { value } = this.state;

        return (
            <input 
                type='text' 
                value={value} 
                className={this.props.className} 
                placeholder={this.props.placeholder} 
                onChange={this.handleChange} 
            />
        );
    }
    
}

export default SimpleDateInput;


/** WEBPACK FOOTER **
 ** ./src/components/SimpleDateInput.js
 **/